import { useMemo } from 'react';
import type { ListCountriesQuery } from '../../../../../../../../../graphql/fragment/audiences/ListCountries.generated';
import type { ListRegionsQuery } from '../../../../../../../../../graphql/fragment/audiences/ListRegions.generated';
import { joinDisplayNames } from '../../../../hooks/utils/mapCodesToNames';

export type UseMarketDisplayLabelsParams = {
  regionCodes: string[];
  countryCodes: string[];
  regions: ListRegionsQuery['region'];
  countries: ListCountriesQuery['country'];
};

export type UseMarketDisplayLabelsReturn = {
  regionLabel: string;
  countryLabel: string;
};

export const useMarketDisplayLabels = ({
  regionCodes,
  countryCodes,
  regions,
  countries,
}: UseMarketDisplayLabelsParams): UseMarketDisplayLabelsReturn => {
  const regionLabel = useMemo(
    () =>
      joinDisplayNames(
        regionCodes,
        regions.map(regionItem => ({ code: regionItem.code, name: regionItem.name }))
      ),
    [regionCodes, regions]
  );

  const countryLabel = useMemo(
    () =>
      joinDisplayNames(
        countryCodes,
        countries.map(countryItem => ({ code: countryItem.code, name: countryItem.name }))
      ),
    [countryCodes, countries]
  );

  return {
    regionLabel,
    countryLabel,
  };
};
